import { actions } from '../../../utils/constants';

export const changeForm = ({target}) => ({
  type: actions.ASYNC_CHANGE_LOGIN_FORM, payload: { id: target.id, value: target.value }
})

export const doLogin = () => ({
  type: actions.ASYNC_LOGIN
})

export const isEnter = ({key}) => ({
  type: actions.CHECK_IF_ENTER, payload: key
}) 


// WEBPACK FOOTER //
// ./src/App/containers/login/login.action.js